import { cva, type VariantProps } from 'class-variance-authority'

// ⚠️ 白抜き文字を載せる背景は**濃い側のトークンを使う**（文字 4.5:1・T-34 実測 2026-08-16）。
// 明るい amber-400 / green-500 / ブランドの赤に白文字を載せると 1.7〜3.1:1 しか出ず、
// 「見えているのに読めない」状態になる。淡い見た目に戻す場合は文字色も一緒に見直すこと。
export const badgeVariants = cva(
  // Prevent badge text from wrapping to a second line
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'bg-primary-dark text-white',
        secondary: 'bg-secondary-dark text-white',
        warning: 'bg-amber-700 text-white',
        outline: 'text-primary-dark border border-primary-dark',
        destructive: 'bg-destructive-text text-white border-transparent',
        success: 'bg-green-700 text-white border-transparent',
        muted: 'bg-gray-500 text-white border-transparent',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export type BadgeVariantProps = VariantProps<typeof badgeVariants>
